import http from "./http-common";

const getDocplaceAuth = () => {
	try {
		const raw = localStorage.getItem("docplace");
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
};

// Keep headers compatible with both gateway styles used in this repo:
// - legacy: customerId/userId
// - gateway: x-client-id/x-user-id
// - shared: Authorization
const buildAuthHeaders = (extra = {}) => {
	const auth = getDocplaceAuth();
	const token = auth?.token;
	const customerId = auth?.customerId;
	const userId = auth?.userId;
	const doctypeId = auth?.doctypeId;

	return {
		"Content-Type": "application/json",
		...(token ? { Authorization: `Bearer ${token}` } : {}),
		...(customerId ? { customerId } : {}),
		...(userId ? { userId } : {}),
		...(customerId ? { "x-client-id": customerId } : {}),
		...(userId ? { "x-user-id": userId } : {}),
		// Several APIs in this repo expect these headers to be present.
		...(doctypeId ? { doctypeId } : {}),
		name: "doc",
		...extra,
	};
};

// Utility function to get client IP address
const getClientIP = async () => {
	try {
		const response = await fetch("https://api.ipify.org?format=json");
		const data = await response.json();
		return data.ip;
	} catch (error) {
		console.error("Error getting client IP:", error);
		return "unknown";
	}
};

export const uploadAnalizeTemplate = (file) => {
	let formData = new FormData();
	let url =
		process.env.REACT_APP_HOST_API + `/forms/api/v1/forms/${1231}/analyze`;

	console.log("file upload", file);
	formData.append("document", file);
	formData.append("use_ai", true);

	return http.post(url, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
			userId: JSON.parse(localStorage.getItem("docplace")).userId,
		},
	});
};

export const getRequestedFormsByTemplateId = (body) => {
	let url =
		process.env.REACT_APP_HOST_API + `/forms/api/v1/search-requested-documents`;
	return http.post(url, body, {
		headers: {
			...buildAuthHeaders(),
		},
	});
};

export const getArchivedFormsByTemplateId = (body, page, pageSize) => {
	let url =
		process.env.REACT_APP_HOST_API +
		`/forms/api/v1/search?page=${page}&pageSize=${pageSize}`;
	return http.post(url, body, {
		headers: {
			...buildAuthHeaders(),
		},
	});
};

export const softDeleteTemplate = (templateId) => {
	const url =
		process.env.REACT_APP_HOST_API +
		`/forms/api/v1/templates/${templateId}/soft-delete`;
	return http.put(
		url,
		{},
		{
			headers: {
				...buildAuthHeaders(),
			},
		}
	);
};

export const renameTemplate = (templateId, templateName) => {
	const url =
		process.env.REACT_APP_HOST_API +
		`/forms/api/v1/templates/${templateId}/name`;
	return http.patch(
		url,
		{ templateName },
		{
			headers: {
				...buildAuthHeaders(),
			},
		}
	);
};

export const restoreTemplate = (templateId) => {
	const url =
		process.env.REACT_APP_HOST_API +
		`/forms/api/v1/templates/${templateId}/restore`;
	return http.put(
		url,
		{},
		{
			headers: {
				...buildAuthHeaders(),
			},
		}
	);
};

export const trashTemplate = (templateId) => {
	const url =
		process.env.REACT_APP_HOST_API + `/forms/api/v1/templates/${templateId}/trash`;
	return http.put(
		url,
		{},
		{
			headers: {
				...buildAuthHeaders(),
			},
		}
	);
};

export const untrashTemplate = (templateId) => {
	const url =
		process.env.REACT_APP_HOST_API +
		`/forms/api/v1/templates/${templateId}/untrash`;
	return http.put(
		url,
		{},
		{
			headers: {
				...buildAuthHeaders(),
			},
		}
	);
};

// Backwards-compatible wrapper (older UI sent { status: 0|1 })
export const recoverArhiveFile = (formTemplateId, body) => {
	if (body?.status === 1) return softDeleteTemplate(formTemplateId);
	if (body?.status === 0) return restoreTemplate(formTemplateId);

	const url =
		process.env.REACT_APP_HOST_API +
		`/forms/api/v1/change-status/${formTemplateId}`;
	return http.put(url, body, {
		headers: {
			...buildAuthHeaders(),
		},
	});
};

export const getTemplateInfoById = (id) => {
	let url =
		process.env.REACT_APP_HOST_API + `/forms/api/v1/templates/${id}/json`;
	return http.get(url, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
			formtemplateid: id,
		},
	});
};

export const updateTemplateFields = (templateId, body) => {
	let url =
		process.env.REACT_APP_HOST_API + `/forms/api/v1/templates/${templateId}`;
	return http.put(url, body, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
			formtemplateid: templateId,
		},
	});
};

export const getTemplateFieldGroups = (templateId) => {
	let url =
		process.env.REACT_APP_HOST_API + `/forms/api/v1/templates/${templateId}/field-groups`;
	return http.get(url, {
		headers: {
			"Content-Type": "application/json",
			accept: "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
		},
	});
};

export const publishFormV2 = async (body) => {
	let url = process.env.REACT_APP_HOST_API + `/forms/api/v1/publish`;

	// Get client IP address
	const clientIP = await getClientIP();

	return http.post(
		url,
		{ ...body, ip_client: clientIP },
		{
			headers: {
				"Content-Type": "application/json",
				Authorization:
					"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
				customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
			},
		}
	);
};
export const getDocFormsToAssign = async () => {
	const response = await http.get(
		`${process.env.REACT_APP_HOST_API}/forms/api/v1/documents?status=pending`,
		{
			headers: {
				"Content-Type": "application/json",
				Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
		}
	);
	return response.data;
};

export const getDocFormPendingReadyForReview = async () => {
	const response = await http.get(`${process.env.REACT_APP_HOST_API}/forms/api/v1/forms-requested/pending`, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
			"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};

/**
 * Cancel a form request (outbox). Sender only. Not allowed when flow is completed.
 * POST /forms/api/v1/forms-requested/flow/{flow_id}/cancel
 */
export const cancelFormRequest = async (flowId) => {
	const url = `${process.env.REACT_APP_HOST_API}/forms/api/v1/forms-requested/flow/${encodeURIComponent(flowId)}/cancel`;
	return http.post(url, {}, {
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
};
export const getDocFormFiller = async (id, formRequestId) => {
	const email = JSON.parse(localStorage.getItem("docplace") || '{"email":""}').email;
	const response = await http.get(`${process.env.REACT_APP_HOST_API}/forms/api/v1/templates/${id}/json?assignee=${email}&form_request_id=${formRequestId}`, {
			headers: {
				"Content-Type": "application/json",
				Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
	});
	return response.data;
};

export const getDocFormFillerBySender = async (id) => {
	const response = await http.get(`${process.env.REACT_APP_HOST_API}/forms/api/v1/templates/${id}/json?assignee=sender`, {
			headers: {
				"Content-Type": "application/json",
				Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
	});
	return response.data;
};

export const getDocFormFillerAllFields = async (id) => {
	const response = await http.get(`${process.env.REACT_APP_HOST_API}/forms/api/v1/templates/${id}/json`, {
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
			userId: JSON.parse(localStorage.getItem("docplace")).userId,
		},
	});
	return response.data;
};

export const getSignatureListByUser = async () => {
	const response = await http.get(`${process.env.REACT_APP_HOST_API}/forms/api/v1/users/signature`, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
			"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};
export const updateSignature = async (signature) => {
	const data = {
		"imageFormat": "png",
		signatureBase64: signature,
	}
	const response = await http.put(`${process.env.REACT_APP_HOST_API}/forms/api/v1/users/signature`, data, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};	


export const fillDocForm = async (id, values) => {
	const response = await http.post(`${process.env.REACT_APP_HOST_API}/forms/api/v1/fill`, {
		formRequestId: id,
		fields: values,
		ip: await getClientIP(),
	}, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
			"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
		},
	});
	return response.data;
};

export const fillDocFormBySender = async (id, values) => {
	const response = await http.post(`${process.env.REACT_APP_HOST_API}/forms/api/v1/fill-sender`, {
		formRequestId: id,
		fields: values,
		ip: await getClientIP(),
	}, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
			"Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
		},
	});
	return response.data;
};

export const appendDocumentToTemplate = async (templateId, documentId, useAi, appendPosition = "end") => {
	const url = `${process.env.REACT_APP_HOST_API}/forms/api/v1/pages/${templateId}/append`;
	const body = {
		document_id: documentId,
		use_ai: useAi,
		append_position: appendPosition,
	};

	return http.post(url, body, {
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
		},
	});
};

export const generateMagicLink = async (formRequestId) => {
	const url = `${process.env.REACT_APP_HOST_API}/forms/api/v1/magic-link/generate-for-form`;
	return http.post(url, { form_request_id: formRequestId }, {
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + JSON.parse(localStorage.getItem("docplace")).token,
			customerId: JSON.parse(localStorage.getItem("docplace")).customerId,
		},
	});
};
